import { type MutationTree } from 'vuex';

import { type IInternalContactLeadState } from './types';

export const RECEIVE_BY_LEAD = 'receiveByLead';

export const mutations: MutationTree<IInternalContactLeadState> = {
    [RECEIVE_BY_LEAD](_state: IInternalContactLeadState, { leadId, idList }: { leadId: number; idList: number[] }) {
        _state.byLead.set(leadId, idList);
    }
};
